module.exports = __webpack_public_path__ + "static/media/icon-Mastercard.49f77f76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-Mastercard.svg
// module id = 2903
// module chunks = 0